import { call, select } from 'redux-saga/effects';
import { gridPanelVoided, selectGridPanel } from 'features/layout/features/content/contentSlice';
import { GridPanelName } from 'features/layout/features/content/types';
import { openLastActiveContentSaga } from 'features/layout/features/content/sagas/openLastActiveContentSaga';

export function* onGridPanelVoidedSaga(action: ReturnType<typeof gridPanelVoided>) {
  const currentPanel: GridPanelName = yield select(selectGridPanel);

  if (action.payload !== currentPanel) {
    return;
  }

  yield call(openLastActiveContentSaga);
}
